/* @flow */
import axios from 'axios'
import type {$AxiosError} from 'axios'
import oPath from 'object-path'

import store from './store'
import router from './router'
import {UPDATE_SESSION, REMOVE_SESSION} from './store/session'

window.axios = axios
axios.defaults.baseURL = '/api/v2'
axios.defaults.timeout = 60000
axios.defaults.headers.common['Accept'] = 'application/vnd.api+json'
axios.defaults.headers.common['Content-Type'] = 'application/vnd.api+json'

if (store.state.session.authToken) {
  axios.defaults.headers.common['X-AUTH-TOKEN'] = store.state.session.authToken
}

axios.interceptors.response.use(
  response => {
    store.commit(UPDATE_SESSION, {
      expiresAt: oPath.get(response, 'headers.x-session-expires-at'),
    })
    return response
  },
  (error: $AxiosError<any>) => {
    const {
      message,
      code = '',
      config: {url, method = ''},
    } = error

    if (!url.includes('eui') && !url.includes('validate')) {
      // eslint-disable-next-line no-console
      console.error(
        `${method.toUpperCase()} ${url} - ${message} - ${code} -`,
        oPath.get(error, 'response.data.errors')
      )
    }

    const detail = oPath.get(error, 'response.data.errors.0.detail')
    if (typeof detail === 'string') {
      if (
        detail.toLowerCase().includes('invalid session') ||
        detail.toLowerCase().includes('session expired')
      ) {
        store.commit(REMOVE_SESSION)
        router.push({
          path: '/login',
          query: {redirect: router.currentRoute.fullPath},
        })
        return
      } else {
        error.message = detail
      }
    }
    return Promise.reject(error)
  }
)



// WEBPACK FOOTER //
// ./src/axios.js